import request from '@/providers/http-service'
const url = `${process.env.VUE_APP_API_DOMAIN}/unified-code`

/**
 * 应急避难人员登记
 * start
 */
// 应急避难人员登记-列表
export function pointList(params) {
  return request({
    url: url + '/gh-point-registration-list/pointList',
    method: 'post',
    data: params
  })
}
// 查看应急避难登记人员名单
export function registerList(params) {
  return request({
    url: url + '/gh-point-registration-list/registerList',
    method: 'post',
    data: params
  })
}
/**
 * 应急避难人员登记
 * end
 */
/**
 * 应急计划管理
 * start
 */
// 查询月厉,填充列表
export function fillMonthList(params) {
  return request({
    url: url + '/gh-emergency-plan-oper-record/fillMonthList',
    method: 'get',
    params
  })
}
//根据计划ids查询列表
export function listByPlanIds(params) {
  return request({
    url: url + '/gh-emergency-plan-oper-record/listByPlanIds',
    method: 'post',
    data: params
  })
}
// 新增发布应急计划
export function createEmergencyPlan(params) {
  return request({
    url: url + '/gh-emergency-plan/createEmergencyPlan',
    method: 'post',
    data: params
  })
}
// 编辑发布的应急计划
export function modifyEmergencyPlan(params) {
  return request({
    url: url + '/gh-emergency-plan/modifyEmergencyPlan',
    method: 'post',
    data: params
  })
}
// 关闭应急计划
export function stopEmergencyPlan(params) {
  return request({
    url: url + '/gh-emergency-plan/stopEmergencyPlan',
    method: 'get',
    params
  })
}
/**
 * 应急计划管理
 * end
 */
/**
 * 应急计划管理
 * start
 */
// 列表查询
export function pageList(params) {
  return request({
    url: url + '/gh-point-emergency/pageList',
    method: 'post',
    data: params
  })
}
// 添加应急点位
export function addEmergency(params) {
  return request({
    url: url + '/gh-point-emergency/add',
    method: 'post',
    data: params
  })
}
// 更新应急点位
export function updateEmergency(params) {
  return request({
    url: url + '/gh-point-emergency/update',
    method: 'post',
    data: params
  })
}
// 删除单条数据
export function delEmergency(params) {
  return request({
    url: url + '/gh-point-emergency/del',
    method: 'get',
    params
  })
}
/**
 * 应急计划管理
 * end
 */



// WEBPACK FOOTER //
// ./src/api/crashInfo.js